import React from "react";
import "./TheParentDashboard.css";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SchoolIcon from "@mui/icons-material/School";
import StarIcon from "@mui/icons-material/Star";
import CreditScoreIcon from "@mui/icons-material/CreditScore";

export default function StudentBio({ name, studentId, grade, school, email, credit, avatar, statusLabel, parent_dashboard_initial_loading }) {
  return (
    <div className="student-bio student-io-card">
      {!parent_dashboard_initial_loading ? (
        <>
          <div className="student-io-header">
            <div className="student-io-avatar">
              <img className="student-avatar" src={avatar} alt="student" />
              {statusLabel ? (
                <span className="student-io-status">{statusLabel}</span>
              ) : null}
            </div>
          </div>
          <div className="student-io-name">{name || "N/A"}</div>
          {/* <div className="student-io-id">Student ID: {studentId || "N/A"}</div> */}
          <div className="student-io-list">
            <div className="student-io-item">
              <span className="student-io-icon">
                <StarIcon fontSize="small" />
              </span>
              <span className="student-io-text">Grade {grade || "N/A"}</span>
            </div>
            <div className="student-io-item">
              <span className="student-io-icon">
                <SchoolIcon fontSize="small" />
              </span>
              <span className="student-io-text">{school || "N/A"}</span>
            </div>
            <div className="student-io-item">
              <span className="student-io-icon">
                <MailOutlineIcon fontSize="small" />
              </span>
              <span className="student-io-text">{email || "N/A"}</span>
            </div>
            <div className="student-io-item student-io-credit">
              <span className="student-io-icon">
                <CreditScoreIcon fontSize="small" />
              </span>
              <span className="student-io-text">Credit availability</span>
              <span className="student-io-credit-pill">{credit || 0}</span>
            </div>
          </div>
        </>
      ) : (
        <div className="row">Loading....</div>
      )}

    </div>
  );
}
